import { Chart as ChartJS, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-date-fns';
import { crosshairGuidesPlugin } from './plugins/crosshairGuidesPlugin';
import { registerSmartTooltipPositioner } from './positioners/smartTooltipPositioner';

let chartExtensionsRegistered = false;

/**
 * Registers all global Chart.js extensions (registerables, plugins, positioners).
 * This function is idempotent — safe to call multiple times.
 */
export const registerChartExtensions = () => {

    // Singleton like pattern. Prevent duplicate global registration.
    if (chartExtensionsRegistered) return;

    // Core Chart.js components (scales, controllers, elements, etc.)
    ChartJS.register(...registerables);

    // Third-party plugins
    ChartJS.register(zoomPlugin);

    // Custom plugins
    ChartJS.register(crosshairGuidesPlugin);

    // Custom utilities
    registerSmartTooltipPositioner();

    chartExtensionsRegistered = true;
};
